import { useState, useEffect, useCallback } from 'react';
import api from '../api';

const TYPE_CONFIG = {
  price:       { label: 'Цена',     color: '#3b82f6', icon: '💰' },
  spp:         { label: 'СПП',      color: '#8b5cf6', icon: '🏷️' },
  ad_spend:    { label: 'Реклама',  color: '#f59e0b', icon: '📢' },
  card_update: { label: 'Карточка', color: '#10b981', icon: '📝' },
  buyout:      { label: 'Выкуп',    color: '#ef4444', icon: '📦' },
  manual:      { label: 'Заметка',  color: '#6b7280', icon: '✏️' },
  stock:       { label: 'Остатки',  color: '#06b6d4', icon: '📦' },
  orders:      { label: 'Заказы',    color: '#10b981', icon: '📋' },
};

function formatEvent(ev) {
  const t = TYPE_CONFIG[ev.type] || { label: ev.type, color: '#6b7280', icon: '📌' };
  let detail = '';
  if (ev.type === 'price') detail = `${ev.data?.from} → ${ev.data?.to} ₽`;
  else if (ev.type === 'spp') detail = `${ev.data?.from}% → ${ev.data?.to}%`;
  else if (ev.type === 'ad_spend') detail = `${Number(ev.data?.spend||0).toLocaleString()} ₽`;
  else if (ev.type === 'orders') detail = `${ev.data?.qty} шт · ${Number(ev.data?.sum||0).toLocaleString()} ₽`;
  else if (ev.type === 'stock' && ev.data?.event === 'zero') detail = `< 10 шт: ${(ev.data?.sizes||[]).join(', ')}`;
  else if (ev.type === 'stock' && ev.data?.event === 'restock') detail = `поставка: ${ev.data?.from} → ${ev.data?.to} шт`;
  else if (ev.note) detail = ev.note;
  return { ...t, detail };
}

const MONTHS = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
const DAYS = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'];

function Calendar({ nmId, onClose }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [logs, setLogs] = useState([]);
  const [hoveredDay, setHoveredDay] = useState(null);
  const [editDay, setEditDay] = useState(null);
  const [viewDay, setViewDay] = useState(null);
  const [editEntryId, setEditEntryId] = useState(null);
  const [editEntryNote, setEditEntryNote] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { loadLogs(); }, [year, month, nmId]);

  const loadLogs = async () => {
    const from = `${year}-${String(month+1).padStart(2,'0')}-01`;
    const lastDay = new Date(year, month+1, 0).getDate();
    const to = `${year}-${String(month+1).padStart(2,'0')}-${String(lastDay).padStart(2,'0')}`;
    try {
      const r = await api.get(`/hypothesis/${nmId}?from=${from}&to=${to}`);
      setLogs(r.data);
    } catch(e) {}
  };

  const saveNote = async () => {
    if (!note.trim()) return;
    setSaving(true);
    try {
      await api.post(`/hypothesis/${nmId}`, { date: editDay, note: note.trim(), type: 'manual' });
      setNote(''); setEditDay(null); loadLogs();
    } catch(e) {}
    setSaving(false);
  };

  const deleteEntry = async (id, e) => {
    e.stopPropagation();
    try { await api.delete(`/hypothesis/entry/${id}`); loadLogs(); } catch(e) {}
  };

  const byDate = {};
  logs.forEach(l => {
    const d = l.date?.split('T')[0];
    if (!byDate[d]) byDate[d] = [];
    byDate[d].push(l);
  });

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month+1, 0).getDate();
  const today = new Date().toISOString().split('T')[0];
  const startOffset = (firstDay + 6) % 7;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.75)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}
      onClick={e=>{ if(e.target===e.currentTarget) onClose(); }}>
      <div style={{background:'#111827',border:'1px solid rgba(255,255,255,0.1)',borderRadius:20,padding:28,width:620,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 25px 60px rgba(0,0,0,0.6)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
          <div style={{fontSize:17,fontWeight:700,color:'#fff'}}>📅 Гипотезы</div>
          <button onClick={onClose} style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.6)',width:28,height:28,borderRadius:8,cursor:'pointer',fontSize:14,display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
          <button onClick={()=>{ if(month===0){setMonth(11);setYear(y=>y-1);}else setMonth(m=>m-1); }}
            style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'#fff',width:32,height:32,borderRadius:8,cursor:'pointer',fontSize:18,display:'flex',alignItems:'center',justifyContent:'center'}}>‹</button>
          <div style={{fontSize:16,fontWeight:700,color:'#fff'}}>{MONTHS[month]} {year}</div>
          <button onClick={()=>{ if(month===11){setMonth(0);setYear(y=>y+1);}else setMonth(m=>m+1); }}
            style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'#fff',width:32,height:32,borderRadius:8,cursor:'pointer',fontSize:18,display:'flex',alignItems:'center',justifyContent:'center'}}>›</button>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:6,marginBottom:6}}>
          {DAYS.map(d=>(
            <div key={d} style={{textAlign:'center',fontSize:10,color:'rgba(200,215,235,0.35)',fontWeight:700,padding:'4px 0'}}>{d}</div>
          ))}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:6}}>
          {Array.from({length:startOffset}).map((_,i)=><div key={`e${i}`}/>)}
          {Array.from({length:daysInMonth}).map((_,i)=>{
            const day = i+1;
            const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
            const events = byDate[dateStr] || [];
            const isToday = dateStr === today;
            const isHovered = hoveredDay === dateStr;
            const hasEvents = events.length > 0;
            return (
              <div key={day} style={{position:'relative'}}>
                <div
                  onMouseEnter={()=>setHoveredDay(dateStr)}
                  onMouseLeave={()=>setHoveredDay(null)}
                  onClick={()=>{ if(events.length>0) setViewDay(dateStr); else { setEditDay(dateStr); setNote(''); } }}
                  onDoubleClick={()=>{setEditDay(dateStr);setNote('');}}
                  title={events.length>0 ? events.map(ev=>{const t=TYPE_CONFIG[ev.type]||{icon:'📌',label:ev.type};const fmt=formatEvent(ev);return `${t.icon} ${fmt.label}${fmt.detail?' · '+fmt.detail:''}`;}).join('\n') : ''}
                  style={{background:isHovered?'rgba(59,130,246,0.2)':hasEvents?'rgba(255,255,255,0.05)':'rgba(255,255,255,0.02)',border:isToday?'1px solid rgba(59,130,246,0.7)':isHovered?'1px solid rgba(59,130,246,0.4)':'1px solid rgba(255,255,255,0.06)',borderRadius:10,padding:'8px 4px 6px',cursor:'pointer',transition:'all 0.15s ease',transform:isHovered?'scale(1.08)':'scale(1)',minHeight:64,zIndex:isHovered?10:1,position:'relative'}}>
                  <div style={{fontSize:12,fontWeight:isToday?700:500,color:isToday?'#60a5fa':'rgba(200,215,235,0.8)',textAlign:'center',marginBottom:4}}>{day}</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:3,justifyContent:'center'}}>
                    {events.slice(0,6).map((ev,ei)=>{
                      const t = TYPE_CONFIG[ev.type]||{color:'#6b7280'};
                      return <div key={ei} style={{width:7,height:7,borderRadius:'50%',background:t.color}}/>;
                    })}
                    {events.length>6 && <div style={{fontSize:8,color:'rgba(200,215,235,0.3)'}}>+{events.length-6}</div>}
                  </div>
                </div>

              </div>
            );
          })}
        </div>
        {/* Модал просмотра событий дня */}
        {viewDay && (
          <div style={{marginTop:20,background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:12,padding:16}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
              <div style={{fontSize:12,fontWeight:600,color:'rgba(200,215,235,0.7)'}}>📅 {viewDay}</div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={()=>{setEditDay(viewDay);setNote('');setViewDay(null);}}
                  style={{background:'rgba(59,130,246,0.15)',border:'1px solid rgba(59,130,246,0.3)',color:'#60a5fa',fontSize:11,padding:'3px 10px',borderRadius:6,cursor:'pointer'}}>
                  + Заметка
                </button>
                <button onClick={()=>setViewDay(null)}
                  style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.5)',fontSize:11,padding:'3px 8px',borderRadius:6,cursor:'pointer'}}>✕</button>
              </div>
            </div>
            {(byDate[viewDay]||[]).map((ev,ei)=>{
              const fmt = formatEvent(ev);
              return (
                <div key={ei} style={{display:'flex',alignItems:'center',gap:8,marginBottom:6,padding:'6px 8px',background:'rgba(255,255,255,0.04)',borderRadius:8}}>
                  <span style={{fontSize:14}}>{fmt.icon}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:11,color:fmt.color,fontWeight:600}}>{fmt.label}</div>
                    {fmt.detail && <div style={{fontSize:10,color:'rgba(200,215,235,0.5)',marginTop:1}}>{fmt.detail}</div>}
                    {ev.type==='manual' && editEntryId===ev.id ? (
                      <div style={{marginTop:6}}>
                        <textarea value={editEntryNote} onChange={e=>setEditEntryNote(e.target.value)} rows={2} autoFocus
                          style={{width:'100%',background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:6,color:'#fff',fontSize:11,padding:'5px 8px',resize:'none',boxSizing:'border-box',outline:'none'}}/>
                        <div style={{display:'flex',gap:6,marginTop:4}}>
                          <button onClick={async()=>{
                            try{
                              await api.delete(`/hypothesis/entry/${ev.id}`);
                              await api.post(`/hypothesis/${nmId}`,{date:viewDay,note:editEntryNote.trim(),type:'manual'});
                              setEditEntryId(null); loadLogs();
                            }catch(e){}
                          }} style={{background:'rgba(59,130,246,0.2)',border:'1px solid rgba(59,130,246,0.4)',color:'#60a5fa',fontSize:10,padding:'3px 10px',borderRadius:5,cursor:'pointer',fontWeight:700}}>Сохранить</button>
                          <button onClick={()=>setEditEntryId(null)} style={{background:'transparent',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.4)',fontSize:10,padding:'3px 8px',borderRadius:5,cursor:'pointer'}}>Отмена</button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div style={{display:'flex',gap:4,flexShrink:0}}>
                    {ev.type==='manual' && (
                      <button onClick={()=>{setEditEntryId(ev.id);setEditEntryNote(ev.note||'');}}
                        style={{background:'rgba(59,130,246,0.1)',border:'1px solid rgba(59,130,246,0.2)',color:'#60a5fa',fontSize:10,padding:'2px 6px',borderRadius:4,cursor:'pointer'}}>✏️</button>
                    )}
                    <button onClick={async(e)=>{e.stopPropagation();try{await api.delete(`/hypothesis/entry/\${ev.id}`);loadLogs();setViewDay(null);setTimeout(()=>setViewDay(viewDay),100);}catch(err){}}}
                      style={{background:'rgba(239,68,68,0.1)',border:'1px solid rgba(239,68,68,0.2)',color:'#ef4444',fontSize:10,padding:'2px 6px',borderRadius:4,cursor:'pointer'}}>🗑</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {editDay && (
          <div style={{marginTop:20,background:'rgba(59,130,246,0.07)',border:'1px solid rgba(59,130,246,0.25)',borderRadius:12,padding:16}}>
            <div style={{fontSize:12,fontWeight:600,color:'#60a5fa',marginBottom:10}}>✏️ Заметка на {editDay}</div>
            <textarea value={note} onChange={e=>setNote(e.target.value)} placeholder="Что было сделано..." rows={3} autoFocus
              style={{width:'100%',background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:8,color:'#fff',fontSize:12,padding:'10px 12px',resize:'vertical',boxSizing:'border-box',outline:'none'}}/>
            <div style={{display:'flex',gap:8,marginTop:10}}>
              <button onClick={saveNote} disabled={saving} style={{background:'rgba(59,130,246,0.25)',border:'1px solid rgba(59,130,246,0.5)',color:'#60a5fa',fontSize:12,padding:'7px 20px',borderRadius:8,cursor:'pointer',fontWeight:700}}>{saving?'Сохраняем...':'Сохранить'}</button>
              <button onClick={()=>setEditDay(null)} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.5)',fontSize:12,padding:'7px 16px',borderRadius:8,cursor:'pointer'}}>Отмена</button>
            </div>
          </div>
        )}
        <div style={{marginTop:20,display:'flex',flexWrap:'wrap',gap:12,padding:'12px 0',borderTop:'1px solid rgba(255,255,255,0.06)'}}>
          {Object.entries(TYPE_CONFIG).map(([k,v])=>(
            <div key={k} style={{display:'flex',alignItems:'center',gap:5}}>
              <div style={{width:8,height:8,borderRadius:'50%',background:v.color}}/>
              <span style={{fontSize:10,color:'rgba(200,215,235,0.4)'}}>{v.icon} {v.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Hypothesis() {
  const [articles, setArticles] = useState([]);
  const [search, setSearch] = useState('');
  const [openNm, setOpenNm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tagFilter, setTagFilter] = useState('all');
  const [showHidden, setShowHidden] = useState(false);

  useEffect(() => {
    api.get('/hypothesis/list/articles').then(r => {
      setArticles(r.data);
      setLoading(false);
    }).catch(()=>setLoading(false));
  }, []);

  const updateSetting = useCallback(async (nmId, key, value, e) => {
    if (e) e.stopPropagation();
    try {
      await api.post(`/hypothesis/settings/${nmId}`, { [key]: value });
      setArticles(prev => prev.map(a => String(a.nm_id)===String(nmId) ? {...a, [key]: value} : a));
    } catch(e) {}
  }, []);

  const handleTag = useCallback((nmId, currentTag, e) => {
    e.stopPropagation();
    const next = currentTag === 'top' ? 'flop' : currentTag === 'flop' ? 'all' : 'top';
    updateSetting(nmId, 'tag', next);
  }, [updateSetting]);

  const handleHide = useCallback((nmId, currentHidden, e) => {
    e.stopPropagation();
    updateSetting(nmId, 'hidden', !currentHidden);
  }, [updateSetting]);

  const hiddenCount = articles.filter(a => a.hidden).length;
  const topCount = articles.filter(a => a.tag === 'top').length;
  const flopCount = articles.filter(a => a.tag === 'flop').length;

  const filtered = articles.filter(a => {
    if (!showHidden && a.hidden) return false;
    if (tagFilter !== 'all' && a.tag !== tagFilter) return false;
    if (search && !(a.vendor_code||'').toLowerCase().includes(search.toLowerCase()) && !String(a.nm_id).includes(search)) return false;
    return true;
  });

  return (
    <div style={{minHeight:'100vh',background:'#0a0f1a',color:'#fff',padding:24}}>
      {/* Шапка */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <h1 style={{fontSize:20,fontWeight:700}}>📅 Гипотезы</h1>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Поиск..."
          style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:8,color:'#fff',fontSize:12,padding:'7px 12px',width:220,outline:'none'}}/>
      </div>

      {/* Фильтры — как в мониторинге */}
      <div style={{display:'inline-grid',gridTemplateColumns:'auto 1px auto 1px auto',gridTemplateRows:'1fr 1fr',alignItems:'stretch',border:'1px solid rgba(255,255,255,0.1)',borderRadius:8,overflow:'hidden',marginBottom:20}}>
        <button onClick={()=>setTagFilter('all')}
          style={{gridColumn:1,gridRow:1,padding:'3px 14px',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='all'?700:400,background:tagFilter==='all'?'rgba(59,130,246,0.2)':'transparent',border:'none',borderBottom:'1px solid rgba(255,255,255,0.1)',color:tagFilter==='all'?'#60a5fa':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>
          ★ Все {articles.filter(a=>!a.hidden).length > 0 ? `(${articles.filter(a=>!a.hidden).length})` : ''}
        </button>
        <button onClick={()=>setShowHidden(s=>!s)}
          style={{gridColumn:1,gridRow:2,padding:'3px 14px',fontSize:11,cursor:'pointer',fontWeight:showHidden?700:400,background:showHidden?'rgba(239,68,68,0.15)':'transparent',border:'none',color:showHidden?'#ef4444':'rgba(200,215,235,0.4)',whiteSpace:'nowrap'}}>
          {showHidden ? `✕ скрыть (${hiddenCount})` : `○ скрытые (${hiddenCount})`}
        </button>
        <div style={{gridColumn:2,gridRow:'1/3',background:'rgba(255,255,255,0.1)'}}/>
        <button onClick={()=>setTagFilter('top')}
          style={{gridColumn:3,gridRow:1,padding:'3px 14px',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='top'?700:400,background:tagFilter==='top'?'rgba(16,185,129,0.2)':'transparent',border:'none',borderBottom:'1px solid rgba(255,255,255,0.1)',color:tagFilter==='top'?'#10b981':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>
          ▲ Топ {topCount > 0 ? `(${topCount})` : ''}
        </button>
        <button onClick={()=>setTagFilter('flop')}
          style={{gridColumn:3,gridRow:2,padding:'3px 14px',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='flop'?700:400,background:tagFilter==='flop'?'rgba(239,68,68,0.2)':'transparent',border:'none',color:tagFilter==='flop'?'#ef4444':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>
          ▼ Слив {flopCount > 0 ? `(${flopCount})` : ''}
        </button>
        <div style={{gridColumn:4,gridRow:'1/3',background:'rgba(255,255,255,0.1)'}}/>
        <div style={{gridColumn:5,gridRow:'1/3',padding:'3px 14px',fontSize:11,color:'rgba(200,215,235,0.3)',display:'flex',alignItems:'center'}}>
          {filtered.length} арт.
        </div>
      </div>

      {loading ? (
        <div style={{color:'rgba(200,215,235,0.4)',fontSize:14}}>Загружаем...</div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:12}}>
          {filtered.map(a => {
            const tag = a.tag || 'all';
            const hidden = a.hidden || false;
            return (
              <div key={a.nm_id} onClick={()=>setOpenNm(a.nm_id)}
                style={{background:'#111827',border: tag==='top' ? '1px solid rgba(16,185,129,0.35)' : tag==='flop' ? '1px solid rgba(239,68,68,0.35)' : '1px solid rgba(255,255,255,0.08)',borderRadius:14,padding:14,cursor:'pointer',transition:'all 0.15s',opacity:hidden?0.45:1,position:'relative'}}
                onMouseEnter={e=>e.currentTarget.style.border=tag==='top'?'1px solid rgba(16,185,129,0.6)':tag==='flop'?'1px solid rgba(239,68,68,0.6)':'1px solid rgba(59,130,246,0.4)'}
                onMouseLeave={e=>e.currentTarget.style.border=tag==='top'?'1px solid rgba(16,185,129,0.35)':tag==='flop'?'1px solid rgba(239,68,68,0.35)':'1px solid rgba(255,255,255,0.08)'}>

                {/* Кнопка тег — топ/слив */}
                <button onClick={e=>handleTag(a.nm_id, tag, e)} title={tag==='all'?'Отметить топ':tag==='top'?'Топ → Слив':'Убрать метку'}
                  style={{position:'absolute',top:6,left:6,background:tag==='top'?'rgba(16,185,129,0.15)':tag==='flop'?'rgba(239,68,68,0.15)':'rgba(255,255,255,0.07)',border:tag==='top'?'1px solid rgba(16,185,129,0.4)':tag==='flop'?'1px solid rgba(239,68,68,0.4)':'1px solid rgba(255,255,255,0.15)',borderRadius:5,color:tag==='top'?'#10b981':tag==='flop'?'#ef4444':'rgba(200,215,235,0.35)',fontSize:10,padding:'1px 5px',cursor:'pointer',lineHeight:1.4}}>
                  {tag==='top'?'▲Топ':tag==='flop'?'▼Слив':'○'}
                </button>

                {/* Кнопка скрыть */}
                <button onClick={e=>handleHide(a.nm_id, hidden, e)} title={hidden?'Показать':'Скрыть'}
                  style={{position:'absolute',top:6,right:6,background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:5,color:hidden?'#ef4444':'rgba(200,215,235,0.25)',fontSize:10,padding:'1px 5px',cursor:'pointer',lineHeight:1.4}}>
                  {hidden?'👁':'–'}
                </button>

                <div style={{display:'flex',gap:10,alignItems:'center',marginBottom:10,marginTop:14}}>
                  {a.photo
                    ? <img src={a.photo} alt="" style={{width:40,height:40,objectFit:'cover',borderRadius:8}}/>
                    : <div style={{width:40,height:40,background:'rgba(255,255,255,0.05)',borderRadius:8}}/>
                  }
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:11,fontWeight:700,color:'#fff',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.vendor_code}</div>
                    <div style={{fontSize:10,color:'rgba(200,215,235,0.4)'}}><span className="blur-nmid">{a.nm_id}</span></div>
                  </div>
                </div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div style={{fontSize:10,color:'rgba(200,215,235,0.4)'}}>
                    {a.events_count > 0 ? `${a.events_count} событий` : 'Нет событий'}
                  </div>
                  {a.last_event && (
                    <div style={{fontSize:9,color:'rgba(200,215,235,0.3)'}}>{a.last_event?.split('T')[0]}</div>
                  )}
                </div>
                {a.events_count > 0 && (
                  <div style={{marginTop:8,height:3,background:'rgba(59,130,246,0.15)',borderRadius:2}}>
                    <div style={{height:'100%',background:tag==='top'?'rgba(16,185,129,0.5)':tag==='flop'?'rgba(239,68,68,0.5)':'rgba(59,130,246,0.5)',borderRadius:2,width:Math.min(100,a.events_count*5)+'%'}}/>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {openNm && <Calendar nmId={openNm} onClose={()=>setOpenNm(null)}/>}
    </div>
  );
}
